<template>
  <b-container>
    <!--- Display of the beautiful APPS/TOOLS/RESOURCES -->
    <block-apps
        v-if="apps && Array.isArray(apps) && apps.length > 0 && displayAppIcons"
        :apps="apps"
        @resource-clicked="handleResourceReveal"
    />
    <vue-bottom-sheet
      v-if="apps && apps.length > 0"
      ref="myBottomSheet"
      max-width="100%"
      max-height="100%"
      :overlay="true"
      overlay-color="#0000004D"
      :click-to-close="myAppSettings_isTapToClose"
      :is-full-screen="true"
      :rounded="false"
      :background-scrollable="true"
      style="z-index: 1000;"
      @opened="handleOpened"
      @closed="handleClosed"
    >
      <div v-if="appLoaded" class="bg-image" :style="styleAppDefined">
        <template>
          <template v-if="settings">
            <resource-match-game
              v-if="selectedResource.toolId === 'Ak9N2bYixeBhwceyleaN' || selectedResource.toolId === 'j8bpt7BRw6Zbr0Qtr34q'"
              :resource="selectedResource"
              :settings="settings"
              :user-data="userData"
              :is-management-mode="isManagementMode"
              :my-app-settings_is-display-activity="
                myAppSettings_isDisplayActivity
              "
              :my-app-settings_is-display-settings="
                myAppSettings_isDisplaySettings
              "
              @app-setup="handleSetUp"
              @appLog="appLog"
              @update-settings="handleUpdateSettings"
            />
            <resource-play-list
              v-else-if="selectedResource.toolId === 'xQrrZAolhCvBFHHrXYEH' || selectedResource.toolId === 'zFw3qR4Nt5mf0avxJfOW'"
              :resource="selectedResource"
              :settings="settings"
              :user-data="userData"
              :is-management-mode="isManagementMode"
              :my-app-settings_is-display-activity="
                myAppSettings_isDisplayActivity
              "
              :my-app-settings_is-display-settings="
                myAppSettings_isDisplaySettings
              "
              @app-setup="handleSetUp"
              @appLog="appLog"
              @update-user-data="handleUpdateUserData"
              @update-settings="handleUpdateSettings"
            />
            <resource-call-log
              v-else-if="selectedResource.toolId === '7nZTpfZkBfRGXsgEBtFb'"
              :resource="selectedResource"
              :settings="settings"
              :user-data="userData"
              :is-management-mode="isManagementMode"
              :my-app-settings_is-display-activity="
                myAppSettings_isDisplayActivity
              "
              :my-app-settings_is-display-settings="
                myAppSettings_isDisplaySettings
              "
              @app-setup="handleSetUp"
              @appLog="appLog"
              @update-user-data="handleUpdateUserData"
              @update-settings="handleUpdateSettings"
            />
            <resource-photo-album
              v-else-if="selectedResource.toolId === 'hIrdo4zaZ2mhwiCR9JPy'"
              :resource="selectedResource"
              :settings="settings"
              :user-data="userData"
              :is-management-mode="isManagementMode"
              :my-app-settings_is-display-activity="
                myAppSettings_isDisplayActivity
              "
              :my-app-settings_is-display-settings="
                myAppSettings_isDisplaySettings
              "
              @app-setup="handleSetUp"
              @appLog="appLog"
              @update-user-data="handleUpdateUserData"
              @update-settings="handleUpdateSettings"
            />
            <resource-my-app-store
              v-else-if="selectedResource.toolId === 'Wa4UZYDTPyB4EFZLkqUt'"
              :resource="selectedResource"
              :settings="settings"
              :user-data="userData"
              :is-management-mode="isManagementMode"
              :my-app-settings_is-display-activity="
                myAppSettings_isDisplayActivity
              "
              :my-app-settings_is-display-settings="
                myAppSettings_isDisplaySettings
              "
              @app-setup="handleSetUp"
              @appLog="appLog"
              @update-user-data="handleUpdateUserData"
              @update-settings="handleUpdateSettings"
            />
            <resource-speak
              v-else-if="selectedResource.toolId === 'BgA5vOyRk21bgw1kAbE7'"
              :resource="selectedResource"
              :settings="settings"
              :user-data="userData"
              :is-management-mode="isManagementMode"
              :my-app-settings_is-display-activity="
                myAppSettings_isDisplayActivity
              "
              :my-app-settings_is-display-settings="
                myAppSettings_isDisplaySettings
              "
              @app-setup="handleSetUp"
              @appLog="appLog"
              @update-user-data="handleUpdateUserData"
              @update-settings="handleUpdateSettings"
            />
            <resource-to-done
              v-else-if="selectedResource.toolId === 'uE0BowtL9licBp44Opsc'"
              :resource="selectedResource"
              :settings="settings"
              :user-data="userData"
              :is-management-mode="isManagementMode"
              :my-app-settings_is-display-activity="
                myAppSettings_isDisplayActivity
              "
              :my-app-settings_is-display-settings="
                myAppSettings_isDisplaySettings
              "
              @app-setup="handleSetUp"
              @appLog="appLog"
              @update-user-data="handleUpdateUserData"
              @update-settings="handleUpdateSettings"
            />
            <resource-medication
                v-else-if="selectedResource.toolId === '1goNyf7FPZre0yOJU2Vx'|| selectedResource.toolId === '8teBzxE5PGUNcqxo81EU'"
                :resource="selectedResource"
                :settings="settings"
                :user-data="userData"
                :is-management-mode="isManagementMode"
                :my-app-settings_is-display-activity="
                myAppSettings_isDisplayActivity
              "
                :my-app-settings_is-display-settings="
                myAppSettings_isDisplaySettings
              "
                @app-setup="handleSetUp"
                @appLog="appLog"
                @update-user-data="handleUpdateUserData"
                @update-settings="handleUpdateSettings"
            />
            <resource-time-sense
              v-else-if="selectedResource.toolId === 'W5Wo0oCDO63yRz0SQKKq'"
              :resource="selectedResource"
              :settings="settings"
              :user-data="userData"
              :is-management-mode="isManagementMode"
              :my-app-settings_is-display-activity="
                myAppSettings_isDisplayActivity
              "
              :my-app-settings_is-display-settings="
                myAppSettings_isDisplaySettings
              "
              @app-setup="handleSetUp"
              @appLog="appLog"
              @update-user-data="handleUpdateUserData"
              @update-settings="handleUpdateSettings"
            />
            <resource-viewer
              v-else-if="selectedResource.toolId === 'GR3fKrrSyDOEIxqUn9ur'"
              :resource="selectedResource"
              :settings="settings"
              :is-management-mode="isManagementMode"
              :my-app-settings_is-display-activity="
                myAppSettings_isDisplayActivity
              "
              :my-app-settings_is-display-settings="
                myAppSettings_isDisplaySettings
              "
              @app-setup="handleSetUp"
              @appLog="appLog"
              @update-settings="handleUpdateSettings"
            />
            <resource-simon-game
              v-else-if="selectedResource.toolId === '0If8J3cuADWx9f4kLi5C'"
              :resource="selectedResource"
              :settings="settings"
              :isManagementMode="isManagementMode"
              @appLog="appLog"
              @update-settings="handleUpdateSettings"
            />
            <resource-serenity-speak
              v-else-if="selectedResource.toolId === 'PX7ROdmtsxdDee9FEwkp'"
              :resource="selectedResource"
              :settings="settings"
              :user-data="userData"
              :is-management-mode="isManagementMode"
              :my-app-settings_is-display-activity="
                myAppSettings_isDisplayActivity
              "
              :my-app-settings_is-display-settings="
                myAppSettings_isDisplaySettings
              "
              @app-setup="handleSetUp"
              @appLog="appLog"
              @update-user-data="handleUpdateUserData"
              @update-settings="handleUpdateSettings"
            />
            <resource-bend
                v-else-if="selectedResource.toolId === 'vah7c0l0wp5S31FkbCnf'"
                :resource="selectedResource"
                :settings="settings"
                :user-data="userData"
                :is-management-mode="isManagementMode"
                :my-app-settings_is-display-activity="
                myAppSettings_isDisplayActivity
              "
                :my-app-settings_is-display-settings="
                myAppSettings_isDisplaySettings
              "
                @app-setup="handleSetUp"
                @appLog="appLog"
                @update-user-data="handleUpdateUserData"
                @update-settings="handleUpdateSettings"
            />
            <resource-solitude
                v-else-if="selectedResource.toolId === 'g7fnZ1ofMjWzKVqyiDNB'"
                :resource="selectedResource"
                :settings="settings"
                :user-data="userData"
                :is-management-mode="isManagementMode"
                :my-app-settings_is-display-activity="
                myAppSettings_isDisplayActivity
              "
                :my-app-settings_is-display-settings="
                myAppSettings_isDisplaySettings
              "
                @app-setup="handleSetUp"
                @appLog="appLog"
                @update-user-data="handleUpdateUserData"
                @update-settings="handleUpdateSettings"
            />
            <resource-sessions
                v-else-if="selectedResource.toolId === 'd32gi61v3LTHd9jTPuwi'"
                :resource="selectedResource"
                :settings="settings"
                :user-data="userData"
                :is-management-mode="isManagementMode"
                :my-app-settings_is-display-activity="
                myAppSettings_isDisplayActivity
              "
                :my-app-settings_is-display-settings="
                myAppSettings_isDisplaySettings
              "
                @app-setup="handleSetUp"
                @appLog="appLog"
                @update-user-data="handleUpdateUserData"
                @update-settings="handleUpdateSettings"
            />
            <resource-tic-tac-toe
              v-else-if="selectedResource.toolId === 'dNkdnpcTrT9xxFwyIPi8'"
              :resource="selectedResource"
              :settings="settings"
              :isManagementMode="isManagementMode"
              @appLog="appLog"
              @update-settings="handleUpdateSettings"
            />
            <resource-slider-game
              v-else-if="selectedResource.toolId === '5CeNANdl7ACJEbyMZ1xy'"
              :resource="selectedResource"
              :isManagementMode="isManagementMode"
            />
            <resource-phrase-game
              v-else-if="selectedResource.toolId === 'lyKfxLnGf5IzqQ63nJgF'"
              :resource="selectedResource"
              :isManagementMode="isManagementMode"
            />
            <resource-check-in
              v-else-if="selectedResource.toolId === 'nuc6WJOaUOtokLI0rPHt'"
              :resource="selectedResource"
              :isManagementMode="isManagementMode"
            />
            <resource-church
              v-else-if="selectedResource.toolId === '59NTA6B2BqabmO0aygpA'"
              :resource="selectedResource"
              :isManagementMode="isManagementMode"
            />
            <resource-wellness
              v-else-if="selectedResource.toolId === 'pGIIoByZZpahJQbgXXDw'"
              :resource="selectedResource"
              :isManagementMode="isManagementMode"
            />
            <resource-documents
              v-else-if="selectedResource.toolId === 'yrkH7rzXYgNrVXK5RG7n'"
              :resource="selectedResource"
              :isManagementMode="isManagementMode"
            />
            <resource-contacts
              v-else-if="selectedResource.toolId === 'iGbatgUDTmF30sdvkr1U'"
              :resource="selectedResource"
              :isManagementMode="isManagementMode"
            />
            <resource-image-challenge
              v-else-if="selectedResource.toolId === 'Vk2W26R7Jsbh20GsTqZR'"
              :resource="selectedResource"
              :settings="settings"
              :isManagementMode="isManagementMode"
              @appLog="appLog"
              @update-settings="handleUpdateSettings"
            />
            <resource-calendar
              v-else-if="selectedResource.toolId === 'pCskZYZInRGIACcTgBwm'"
              :resource="selectedResource"
              :settings="settings"
              :isManagementMode="isManagementMode"
              @appLog="appLog"
              @update-settings="handleUpdateSettings"
            />
            <resource-serene
              v-else-if="selectedResource.toolId === 'x3X1lsQNK9JH174NmfpM'"
              :resource="selectedResource"
              :settings="settings"
              :isManagementMode="isManagementMode"
              @appLog="appLog"
              @update-settings="handleUpdateSettings"
            />
            <resource-bubble-pop
              v-else-if="selectedResource.toolId === 'hX6BYVXHaKJ0UP5muW65'"
              :resource="selectedResource"
              :settings="settings"
              :isManagementMode="isManagementMode"
              @appLog="appLog"
              @update-settings="handleUpdateSettings"
            />
            <resource-care-plan
              v-else-if="selectedResource.toolId === 'tRvy6dXSRWiPkcrxIYkY'"
              :resource="selectedResource"
              :settings="settings"
              :isManagementMode="isManagementMode"
              @appLog="appLog"
              @update-settings="handleUpdateSettings"
            />
            <resource-check-list
              v-else-if="selectedResource.toolId === 'OYGAhCAsMBjrLf5hwiPG'"
              :resource="selectedResource"
              :settings="settings"
              :isManagementMode="isManagementMode"
              @appLog="appLog"
              @update-settings="handleUpdateSettings"
            />
            <resource-live
              v-else-if="selectedResource.toolId === 'iH01Lj6jvWdncq6NpG6c'"
              :resource="selectedResource"
              :settings="settings"
              :isManagementMode="isManagementMode"
              @appLog="appLog"
              @update-settings="handleUpdateSettings"
            />
            <resource-social-locker
              v-else-if="selectedResource.toolId === '7dfByIq7bCEBHCgDPnpN'"
              :resource="selectedResource"
              :settings="settings"
              :isManagementMode="isManagementMode"
              @appLog="appLog"
              @update-settings="handleUpdateSettings"
            />
            <resource-template
              v-else-if="selectedResource.toolId === 'fNjPfazpv65NltoVigko'"
              :resource="selectedResource"
              :settings="settings"
              :isManagementMode="isManagementMode"
              @appLog="appLog"
              @update-settings="handleUpdateSettings"
            />
            <resource-box-it
              v-else-if="selectedResource.toolId === 'YXG4YwNRs5oAQInAlVDY'"
              :resource="selectedResource"
              :settings="settings"
              :isManagementMode="isManagementMode"
              @appLog="appLog"
              @update-settings="handleUpdateSettings"
            />
            <resource-co-blink
              v-else-if="selectedResource.toolId === '7zSTYGh3gkqibVR70Ph1'"
              :resource="selectedResource"
              :settings="settings"
              :isManagementMode="isManagementMode"
              @appLog="appLog"
              @update-settings="handleUpdateSettings"
            />
            <resource-tracker
              v-else-if="selectedResource.toolId === 'iHvWgl1PjbGR9XAsRvYW'"
              :resource="selectedResource"
              :settings="settings"
              :isManagementMode="isManagementMode"
              @appLog="appLog"
              @update-settings="handleUpdateSettings"
            />
            <resource-bible
              v-else-if="selectedResource.toolId === '4qgeC0xaiIbmLfrjGZ2w'"
              :resource="selectedResource"
              :settings="settings"
              :isManagementMode="isManagementMode"
              @appLog="appLog"
              @update-settings="handleUpdateSettings"
            />
            <resource-caregiver
              v-else-if="selectedResource.toolId === 'X2XD291UsTkmTByERztz'"
              :resource="selectedResource"
              :settings="settings"
              :isManagementMode="isManagementMode"
              @appLog="appLog"
              @update-settings="handleUpdateSettings"
            />
            <resource-notes-board
              v-else-if="selectedResource.toolId === 'GSqrxuZto70rDH78hwUG'"
              :resource="selectedResource"
              :settings="settings"
              :isManagementMode="isManagementMode"
              @appLog="appLog"
              @update-settings="handleUpdateSettings"
            />
            <resource-blog-vault
              v-else-if="selectedResource.toolId === 'eEH2zMShmqDU5cNu6k45'"
              :resource="selectedResource"
              :settings="settings"
              :isManagementMode="isManagementMode"
              @appLog="appLog"
              @update-settings="handleUpdateSettings"
            />
            <resource-yoga-ease
              v-else-if="selectedResource.toolId === 'QQODGZNAtPabavVLODiU'"
              :resource="selectedResource"
              :settings="settings"
              :isManagementMode="isManagementMode"
              @appLog="appLog"
              @update-settings="handleUpdateSettings"
            />
            <resource-simon-game
              v-else
              :resource="selectedResource"
              :settings="settings"
              :isManagementMode="isManagementMode"
              @appLog="appLog"
              @update-settings="handleUpdateSettings"
            />
          </template>
        </template>
        <!------ NOTIFICATION LAYER -Cleanup More and @ToDo Move to a central area -->
        <b-alert
          :show="bottomAlert.dismissCountDown"
          class="position-fixed fixed-bottom m-0 rounded-0"
          style="z-index: 2000;"
          :variant="bottomAlert.variant"
          :dismissible="bottomAlert.isDismissable"
          :fade="true"
          @dismissed="bottomAlert.dismissCountDown = 0"
        >
          {{ bottomAlert.description }}
        </b-alert>
      </div>
      <div v-else></div>
    </vue-bottom-sheet>
  </b-container>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";
import BlockApps from "./blockApps";
import ResourceBoxIt from "@/components/blockResources/resourceBoxIt";
import ResourceCoBlink from "@/components/blockResources/resourceCoBlink";
import ResourceTracker from "@/components/blockResources/resourceTracker";
import ResourceToDone from "@/components/blockResources/resourceToDone";
import ResourceContacts from "@/components/blockResources/resourceContacts";
import ResourceSpeak from "@/components/blockResources/resourceSpeak";
import ResourceCallLog from "@/components/blockResources/resourceCallLog";
import ResourceCheckIn from "@/components/blockResources/resourceCheckIn";
import ResourceChurch from "@/components/blockResources/resourceChurch";
import ResourceMatchGame from "@/components/blockResources/resourceMatchGame";
import ResourceSimonGame from "@/components/blockResources/resourceSimonGame";
import ResourceTicTacToe from "@/components/blockResources/resourceTicTacToe";
import ResourceSliderGame from "@/components/blockResources/resourceSliderGame";
import ResourcePhraseGame from "@/components/blockResources/resourcePhraseGame";
import ResourcePhotoAlbum from "@/components/blockResources/resourcePhotoAlbum";
import ResourceDocuments from "@/components/blockResources/resourceDocuments";
import ResourceMedication from "@/components/blockResources/resourceMedication";
import ResourceWellness from "@/components/blockResources/resourceWellness";
import ResourceImageChallenge from "@/components/blockResources/resourceImageChallenge";
import ResourceSerene from "@/components/blockResources/resourceSerene";
import ResourceCalendar from "@/components/blockResources/resourceCalendar";
import ResourceBubblePop from "@/components/blockResources/resourceBubblePop";
import ResourceCheckList from "@/components/blockResources/resourceCheckList";
import ResourceCarePlan from "@/components/blockResources/resourceCarePlan";
import ResourcePlayList from "@/components/blockResources/resourcePlayList";
import ResourceTemplate from "@/components/blockResources/resourceTemplate";
import ResourceLive from "@/components/blockResources/resourceLive";
import ResourceSocialLocker from "@/components/blockResources/resourceSocialLocker";
import ResourceBible from "@/components/blockResources/resourceBible";
import ResourceCaregiver from "@/components/blockResources/resourceCaregiver";
import ResourceNotesBoard from "@/components/blockResources/resourceNotesBoard";
import ResourceBlogVault from "@/components/blockResources/resourceBlogVault";
import ResourceViewer from "@/components/blockResources/resourceViewer";
import ResourceYogaEase from "@/components/blockResources/resourceYogaEase";
import ResourceSerenitySpeak from "@/components/blockResources/resourceSerenitySpeak";
import ResourceTimeSense from "@/components/blockResources/resourceTimeSense";
import ResourceMyAppStore from "@/components/blockResources/resourceMyAppStore";
import ResourceBend from "@/components/blockResources/resourceBend";
import ResourceSolitude from "@/components/blockResources/resourceSolitude";
import ResourceSessions from "@/components/blockResources/resourceSessions";
export default {
  name: "Block_ShelfResources",
  components: {
    VueBottomSheet,
    BlockApps,
    ResourceSolitude,
    ResourceToDone,
    ResourceCallLog,
    ResourceCheckIn,
    ResourceChurch,
    ResourceContacts,
    ResourceMatchGame,
    ResourceSimonGame,
    ResourceTicTacToe,
    ResourceSliderGame,
    ResourceSpeak,
    ResourcePhraseGame,
    ResourcePhotoAlbum,
    ResourceWellness,
    ResourceMedication,
    ResourceDocuments,
    ResourceImageChallenge,
    ResourceSerene,
    ResourceCalendar,
    ResourceBubblePop,
    ResourceCheckList,
    ResourcePlayList,
    ResourceCarePlan,
    ResourceLive,
    ResourceTemplate,
    ResourceSocialLocker,
    ResourceCoBlink,
    ResourceBoxIt,
    ResourceTracker,
    ResourceBible,
    ResourceCaregiver,
    ResourceNotesBoard,
    ResourceBlogVault,
    ResourceViewer,
    ResourceYogaEase,
    ResourceTimeSense,
    ResourceSerenitySpeak,
    ResourceMyAppStore,
    ResourceBend,
    ResourceSessions
  },
  created() {},
  mounted() {
    if (this.resourcePath) {
      this.handleResourceOnLoad(this.resourcePath);
    }
  },
  props: {
    viewingId: {
      type: String,
      required: true,
      default: null //'kOF8wg4YyIfIfgS3kSjr2iQnAAU2'
    },
    apps: {
      type: Array,
      required: false,
      default: () => { return []}
    },
    displayAppIcons: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      profile: "user/profile",
      appSettings: "user/appsSettings",
      settingsUser: "tools/settingsUser",
      settingsGen: "tools/settingsGen"
    }),
    appLoaded() {
      return this.settingsLoaded && this.userDataLoaded;
    },
    hasSeenAboutIntro() {
      return appSettings &&
        appSettings.hasSeenAboutIntro !== undefined &&
        appSettings.hasSeenAboutIntro !== null
        ? appSettings.hasSeenAboutIntro
        : true;
    },
    styleAppDefined() {
      switch (this.useStyleClass) {
        case "bgColor":
          return `background-color: ${this.bgColor}; height:100vh;`;
          break;
        case "bgImg":
          return `background-image: url(${this.bgImgURL}); height:100vh;`;
          break;
      }
      return "";
    },
    myAppSettings_isTapToClose() {
      return this.profile &&
        this.profile.settings &&
        this.profile.settings.myApps &&
        this.profile.settings.myApps.isTapToClose
        ? this.profile.settings.myApps.isTapToClose
        : false;
    },
    myAppSettings_isDisplayActivity() {
      return this.profile &&
        this.profile.settings &&
        this.profile.settings.myApps &&
        this.profile.settings.myApps.isDisplayActivity
        ? this.profile.settings.myApps.isDisplayActivity
        : false;
    },
    myAppSettings_isDisplaySettings() {
      return this.profile &&
        this.profile.settings &&
        this.profile.settings.myApps &&
        this.profile.settings.myApps.isDisplaySettings
        ? this.profile.settings.myApps.isDisplaySettings
        : false;
    }
  },
  methods: {
    handleSetUp(appSetUp) {
      if (appSetUp.useStyleClass !== null)
        this.useStyleClass = appSetUp.useStyleClass;
      if (appSetUp.bgImgURL !== null) this.bgImgURL = appSetUp.bgImgURL;
    },

    //**** VIEWER | VIEWING ***/

    //READING
    getAppSettingsForAppId(appId) {
      this.$store
        .dispatch("user/getAppSettingsForAppId",
            {
              appId: appId,
              viewingId: this.viewingId
            }
        )
        .then(appSettings => {
          this.settings = appSettings; //settings always has the be fresh
          this.settingsLoaded = true;
        });
    },
    getAppUserDataForAppId(appId) {
      this.$store
        .dispatch("user/getAppUserDataForAppId",
            {
              appId: appId,
              viewingId: this.viewingId
            }
        )
        .then(appUserData => {
          this.userData = appUserData; //data always has the be fresh
          this.userDataLoaded = true;
        }); //need error
    },


    //WRITING
    /**** UPDATING APP NEEDS ****/
    handleUpdateAppTracks(resource) {
      //Track DeviceType, GeoLocation, BrowserType
      if (this.tracks.length > 0 && this.isTrackingApps) {
        //@ToDo:The tracks need to send even if the ip fails
        //@ToDo: Implement a finally to just always submit tracks
        axios.get("https://api.ipify.org?format=json").then(res => {
          let ip = res.data.ip;
          this.$store.dispatch("user/updateAppTracks", {
            app: resource,
            tracks: this.tracks,
            ip: ip,
            viewingId: this.viewingId
          });
        });
      }
    },
    handleUpdateSettings() {
      if (this.settings) {
        //Update the User's Settings
        if (this.settings) {
          let toolIdx = `tool_${this.selectedResource.toolId}`;

          this.settings.user =
              this.settingsUser && this.settingsUser[toolIdx]
                  ? this.settingsUser[toolIdx].settings
                  : {};

          this.settings.gen =
              this.settingsGen && this.settingsGen[toolIdx]
                  ? this.settingsGen[toolIdx].settings
                  : {};
        }

        this.$store
            .dispatch("user/updateAppSettings", {
              app: this.selectedResource,
              settings: this.settings,
              viewingId: this.viewingId
            })
            .then(res => {
              let payload = {
                title: "Settings Saved",
                description: "Congrats you have saved your changes",
                variant: "success"
              };

              //Refresh Data to latest
              if (this.selectedResource.toolId) {
                this.getAppSettingsForAppId(this.selectedResource.toolId);
                //this.getAppUserDataForAppId(this.selectedResource.toolId);
              }
              // if( showNotif === undefined || showNotif=== true ) {
              this.handleShowUserNotification(payload);
              // }
            })
            .catch(error => {
              this.$nprogress.done();

              let payload = {
                title: error.code,
                description: error.message,
                variant: "danger"
              };
              this.handleShowUserNotification(payload);
            });
      }
    },
    handleUpdateUserData({ userData, key, notif }) {
      this.$store
          .dispatch("user/updateAppUserData", {
            tool: this.selectedResource,
            data: userData,
            key: key,
            viewingId: this.viewingId
          })
          .then(res => {
            //place latest update in the store
            this.$store.dispatch("tools/setUserDataUpdate", userData);
            this.getAppUserDataForAppId(this.selectedResource.toolId);
            this.handleShowUserNotification(notif);
            this.$store.dispatch("tools/setUserDataUpdate", userData);
          })
          .catch(rej => {
            this.$nprogress.done();
            const payload = {
              title: notif.title,
              description: rej.message,
              variant: "danger"
            };
            notif = payload;
            this.handleShowUserNotification(notif);
          });
    },

    //*** VIEWER/VIEWING END **/

    //*** IN APP NOTIFS ***/
    handleShowUserNotification(message) {
      //this.handleShowBottomAlertWithMessage(message);
      this.$store.dispatch("user/showNotification", {
        title: message.title,
        description: message.description,
        variant: message.variant
      });
    },
    handleShowBottomAlertWithMessage(message) {
      for (const key in this.bottomAlert) {
        if (this.bottomAlert.hasOwnProperty(key)) {
          if (message[key]) this.bottomAlert[key] = message[key];
        }
      }
      //Activate to  go
      this.bottomAlert.showBottomAlert = true; //mot needed on dimisss countdown
      this.bottomAlert.dismissCountDown = 3;
    },
    handleOpened() {
      this.appLog({
        name: "open",
        payload: { resource: this.selectedResource },
        level: "info"
      });
    },
    handleClosed() {
      this.appLog({
        name: "close",
        payload: { resource: this.selectedResource },
        level: "info"
      });

      //Reset Env
      this.handleUpdateAppTracks(this.selectedResource);
      this.selectedResource = {};
      this.useStyleClass = false;
      this.settings = null;
    },
    handleResourceOnLoad(resourcePath) {
      const theResource = this.apps.filter(aResource => {
        return aResource.name.toLowerCase() === resourcePath.toLowerCase();
      })[0];

      if (theResource) {
        console.log(`Opening ${theResource.text}`);
        this.handleResourceReveal(theResource);
      } else {
        console.log("No resource");
      }
    },
    async handleResourceReveal(resource) {
      debugger
      if (resource.toolId) {

        if (this.viewingId) {
          await this.getAppSettingsForAppId(resource.toolId);
          await this.getAppUserDataForAppId(resource.toolId);
         }
      }
      this.selectedResource = resource;
      this.$refs.myBottomSheet.open();
      this.tracks = [];
    },
    appLog({ name, payload, level }) {
      let track = {
        user: this.user.uid,
        name: name,
        payload: payload,
        level: level ? level : "log", // 'debug' | 'info' | 'warn' | 'error' | 'log'
        _created_at: new Date()
      };
      this.tracks.push(track);
    },
  },
  data() {
    return {
      useStyleClass: "none", //none, bgColor, bgImg
      bgColor: "#000000",
      bgImgURL: "https://mdbcdn.b-cdn.net/img/new/fluid/nature/011.webp",
      isManagementMode: true, //maybe not
      bottomAlert: {
        dismissCountDown: 0,
        showBottomAlert: false,
        variant: "success",
        isDismissable: true,
        description: "This IS your App Messaging/Notifications"
      },
      settings: null,
      userData: null,
      /*=------- */
      showTop: false,
      settingsLoaded: false,
      userDataLoaded: false,
      selectedResource: {},
      tracks: [],
      isTrackingApps: true,
      showAboutOfAboutIntro: false // move to state
    };
  }
};
</script>

<style lang="css" scoped>
.gradient-custom {
  /* fallback for old browsers */
  background: #a18cd1;
  /* Chrome 10-25, Safari 5.1-6 */
  background: -webkit-linear-gradient(
    45deg,
    rgba(29, 236, 197, 0.6),
    rgba(91, 14, 214, 0.6) 100%
  );

  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background: linear-gradient(
    45deg,
    rgba(29, 236, 197, 0.6),
    rgba(91, 14, 214, 0.6) 100%
  );
}
</style>
